import React from "react";

import {Button, IconButton} from "@mui/material";

import {CxIcon} from "./CxIcon";
import {CxTooltip} from "./CxTooltip";

export function CxTextButton({ label, variant, onClick, disabled=false, sx }) {
    return (
        <Button variant={variant}
                disabled={disabled}
                onClick={onClick} sx={sx}>
            {label}
        </Button>
    );
}

export function CxIconButton({ label, iconName, onClick, disabled=false,  sx }) {
    return (
        <Button variant="contained" startIcon={<CxIcon name={iconName} />}
                disabled={disabled}
                onClick={onClick} sx={sx}>
            { label }
        </Button>
    );
}

export function CxIconButtonSecondary({ label, iconName, onClick, disabled=false,  sx }) {
    return (
        <Button variant="outlined" color="info" startIcon={<CxIcon name={iconName} />}
                disabled={disabled}
                onClick={onClick} sx={sx}>
            { label }
        </Button>
    );
}

export function CxTooltipButton({ label, iconName, onClick, disabled=false, sx }) {
    return (
        <CxTooltip title={label} placement="bottom-end">
            <IconButton edge="end" color="primary"
                        disabled={disabled}
                        onClick={onClick} sx={sx}>
                <CxIcon name={iconName} />
            </IconButton>
        </CxTooltip>
    );
}

export function CxTooltipTextButton({ label, tooltip, onClick, disabled=false, sx }) {
    return (
        <CxTooltip title={tooltip} placement="bottom-end">
            <Button disabled={disabled} onClick={onClick} sx={sx}>
                {label}
            </Button>
        </CxTooltip>
    );
}


export function CxButton({ kind = "icon", label, iconName, tooltip, onClick, disabled=false, sx }) {
    switch (kind) {
        case "text":
            return <CxTextButton label={label} onClick={onClick} disabled={disabled} sx={sx} />;
        case "icon":
            return <CxIconButton label={label} iconName={iconName} onClick={onClick} disabled={disabled} sx={sx} />;
        case "tooltip":
            return <CxTooltipButton label={label} iconName={iconName} onClick={onClick} disabled={disabled} sx={sx} />;
        default:
            console.error(`Unknown kind: ${kind}`);
            return null;
    }
}
